import * as d3 from 'd3';

// Real OHLC tick bars -- vertical high-low line + a left tick at open and a
// right tick at close. The old "Bar" chart type was mislabeled: it actually
// drew a plain close-price column chart (bars from 0 to close), not an OHLC
// bar chart at all. This is the genuine, standard "Bars" rendering every
// trading platform (including TradingView) means by that name.
const bar = {
  id: 'bar',
  label: 'Bars',
  getYExtent(data) {
    return [d3.min(data, (d) => d.low), d3.max(data, (d) => d.high)];
  },
  draw({ group, data, xScale, yScale, theme, barWidth }) {
    const tickLen = Math.max(2, barWidth * 0.6);

    const stems = group.selectAll('.mark-stem').data(data, (d) => d.date);
    stems.exit().remove();
    stems
      .enter()
      .append('line')
      .attr('class', 'mark-stem')
      .merge(stems)
      .attr('x1', (d) => xScale(d.date))
      .attr('x2', (d) => xScale(d.date))
      .attr('y1', (d) => yScale(d.high))
      .attr('y2', (d) => yScale(d.low))
      .attr('stroke', (d) => (d.close >= d.open ? theme.bull.strong : theme.bear.strong))
      .attr('stroke-width', 1.5);

    const opens = group.selectAll('.mark-open-tick').data(data, (d) => d.date);
    opens.exit().remove();
    opens
      .enter()
      .append('line')
      .attr('class', 'mark-open-tick')
      .merge(opens)
      .attr('x1', (d) => xScale(d.date) - tickLen)
      .attr('x2', (d) => xScale(d.date))
      .attr('y1', (d) => yScale(d.open))
      .attr('y2', (d) => yScale(d.open))
      .attr('stroke', (d) => (d.close >= d.open ? theme.bull.strong : theme.bear.strong))
      .attr('stroke-width', 1.5);

    const closes = group.selectAll('.mark-close-tick').data(data, (d) => d.date);
    closes.exit().remove();
    closes
      .enter()
      .append('line')
      .attr('class', 'mark-close-tick')
      .merge(closes)
      .attr('x1', (d) => xScale(d.date))
      .attr('x2', (d) => xScale(d.date) + tickLen)
      .attr('y1', (d) => yScale(d.close))
      .attr('y2', (d) => yScale(d.close))
      .attr('stroke', (d) => (d.close >= d.open ? theme.bull.strong : theme.bear.strong))
      .attr('stroke-width', 1.5);
  },
  tooltipFields(d) {
    return { open: d.open, high: d.high, low: d.low, close: d.close, volume: d.volume };
  },
};

export default bar;
